import { DAW, ShortDAW } from 'types'

export const labelForDAW = (dawNumber: number): string => {
  return `${dawNumber} - ${DAW[dawNumber]}`
}

export const shortLabelForDAW = (dawNumber: number): string => {
  return `${dawNumber} - ${ShortDAW[dawNumber]}`
}
